import { DropdownMenu } from './DropdownMenu';
import { DropdownMenuBanner } from './DropdownMenuBanner';
import { DropdownMenuButton } from './DropdownMenuButton';
import { DropdownMenuContent } from './DropdownMenuContent';
import { DropdownMenuItem } from './DropdownMenuItem';
import { DropdownMenuTrigger } from './DropdownMenuTrigger';

export type { DropdownMenuProps } from './DropdownMenu';
export type { DropdownMenuItemProps } from './DropdownMenuItem';
export type { DropdownMenuTriggerProps } from './DropdownMenuTrigger';
export type { DropdownMenuContentProps } from './DropdownMenuContent';

type DropdownMenuBastion = typeof DropdownMenu & {
  Item: typeof DropdownMenuItem;
  Button: typeof DropdownMenuButton;
  Content: typeof DropdownMenuContent;
  Banner: typeof DropdownMenuBanner;
  Trigger: typeof DropdownMenuTrigger;
};

const Bastion = DropdownMenu as DropdownMenuBastion;
Bastion.Item = DropdownMenuItem;
Bastion.Button = DropdownMenuButton;
Bastion.Content = DropdownMenuContent;
Bastion.Banner = DropdownMenuBanner;
Bastion.Trigger = DropdownMenuTrigger;

export { Bastion as DropdownMenu, DropdownMenuItem, DropdownMenuTrigger };
